import NODE10 from "@/statics/devices/Node10/header.js";
import NODE11 from "@/statics/devices/Node11/header.js";
import NODE12 from "@/statics/devices/Node12/header.js";
import NODE13 from "@/statics/devices/Node13/header.js";
import NODE14 from "@/statics/devices/Node14/header.js";
import NODE15 from "@/statics/devices/Node15/header.js";
import NODE16 from "@/statics/devices/Node16/header.js";
import NODE17 from "@/statics/devices/Node17/header.js";
import NODE18 from "@/statics/devices/Node18/header.js";
import NODE2 from "@/statics/devices/Node2/header.js";
import NODE3 from "@/statics/devices/Node3/header.js";
import NODE4 from "@/statics/devices/Node4/header.js";
import NODE5 from "@/statics/devices/Node5/header.js";
import NODE6 from "@/statics/devices/Node6/header.js";
import NODE7 from "@/statics/devices/Node7/header.js";
import NODE8 from "@/statics/devices/Node8/header.js";
import NODE9 from "@/statics/devices/Node9/header.js";
import NODE101 from "@/statics/devices/Node101/header.js";
//TODO: add nodes here
const NODES = [null, null, NODE2, NODE3, NODE4, NODE5, NODE6, NODE7, NODE8, NODE9, NODE10, NODE11, NODE12, NODE13, NODE14, NODE15, NODE16, NODE17, NODE18];
NODES[101] = NODE101;
export default NODES;
